import React from 'react';
import { useNavigate } from 'react-router-dom';
import './wikiCrumbs.css';

/**
 * The prototype's in-content breadcrumb (spec B §1.2.2 category view, §1.3.2
 * page view — kept in edit mode too): `Wiki / Category [/ Subcategory] [/ Page]`.
 *
 * `items` = `[{ label, to? }]`. Every crumb is a button; one with a `to`
 * navigates there (the prototype's last category crumb re-opens itself), one
 * without is inert (the page-title crumb). The last crumb is the current
 * location (`aria-current="page"`, dark + 500).
 */
export default function WikiCrumbs({ items, testId = 'wiki-crumbs' }) {
    const navigate = useNavigate();
    const list = (items || []).filter((item) => item && item.label);
    return (
        <nav className="wk-crumbs" aria-label="Breadcrumb" data-testid={testId}>
            <ol>
                {list.map((item, index) => {
                    const last = index === list.length - 1;
                    return (
                        <li key={`${index}-${item.label}`}>
                            {index > 0 && <span className="wk-crumb-sep" aria-hidden="true">/</span>}
                            <button
                                type="button"
                                className="wk-crumb"
                                aria-current={last ? 'page' : undefined}
                                onClick={() => { if (item.to) navigate(item.to); }}
                            >
                                {item.label}
                            </button>
                        </li>
                    );
                })}
            </ol>
        </nav>
    );
}
